//
//
//
//
//

import config from "@/config";

export default {
  components: {},
  data() {
    return {
      user_id: "",
      password: ""
    };
  },
  computed: {
    appTitle() {
      return config.appTitle;
    },
    username() {
      return this.$store.getters.username;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    }
  },
  mounted() {
    setTimeout(() => {
      if (this.isLoggedIn) {
        this.$router.push("/system");
      } else {
        this.$router.push("/login");
      }
    }, 1000);
  },
  methods: {}
};
